import { Formio } from 'react-formio';
import ace from 'ace-builds';
// import * as Flatpickr from 'flatpickr';
import Flatpickr from 'flatpickr';
import Ckeditor from '@ckeditor/ckeditor5-build-classic';
import 'ace-builds/webpack-resolver';
import 'flatpickr/dist/flatpickr.min.css';

declare module 'react-formio';

declare global {
  interface Window {
    ace: typeof ace;
    Flatpickr: typeof Flatpickr;
    ClassicEditor: typeof Ckeditor;
  }
}

const originalRequireLibrary = Formio.requireLibrary;

Formio.requireLibrary = function requireLibrary(name: string, property: string, src: string, polling: unknown) {
  if (name === 'ace') {
    ace.config.set('loadWorkerFromBlob', false);
    window.ace = ace;
    return Promise.resolve(ace);
  }
  if ((name === 'flatpickr-css' || name === 'flatpickr')) {
    window.Flatpickr = Flatpickr;
    return Promise.resolve(Flatpickr);
  }
  if (name === 'ckeditor') {
    window.ClassicEditor = Ckeditor;
    return Promise.resolve(Ckeditor);
  }
  // eslint-disable-next-line no-console
  console.warn('Unknown library requested', name, property, src, polling);
  return originalRequireLibrary(name, property, src, polling);
};

export { Formio };
